<!-- header -->
<template>
  <div class="layout-header">
    <el-row>
      <el-col
        :span="12"
        class="clearfix"
      />
      <el-col :span="12">
        <div
          class="right align-middle"
          style="margin-right:32px;height:62px"
        >
          <span class="welcome">{{ $t("head.hyn") }}，</span>
          <span class="name">{{ name }}</span>
          <el-button size="medium" class="exit" icon="el-icon-switch-button" type="text" @click="loginOut" />
          <language style="padding-left: 10px;" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import language from './Language.vue'
export default {
  components: { language },
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      logo: ''
    }
  },
  mounted () {
    // this.getLogo()
  },
  beforeDestroy () {
    this.$bus.$off('logo')
  },
  methods: {
    // 注销
    loginOut () {
      this.$confirm(this.$t('notice.qdtc'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      })
        .then(() => {
          if (this.$store.state.user.flag === 1) {
            this.$store.dispatch('user/logout')
              .then(() => {
                this.$router.push({ path: '/login' })
              })
          } else {
            this.$store.dispatch('user/logoutmeter')
              .then(() => {
                this.$router.push({ path: '/loginmeter' })
              })
          }
        })
        .catch(() => {})
    },
  }
}
</script>
<style lang='stylus' scoped>
.layout-header
  background-color #1C2550
  height 60px
  position relative
  left 190px
  width calc(100% - 190px)
  box-sizing border-box
div
  margin 0
  line-height 60px
  .logo
    height 40px
    margin-left 30px
    max-width 300px
    overflow: hidden
    background-color red
.el-dropdown-link
  color #ffffff
  cursor pointer
.el-icon-arrow-down
  color #ffffff
.el-col
  height 60px
.back
  color #ffffff
  margin-left 30px
  i
    cursor pointer
    font-size 24px
  span
    font-size 18px
    margin-left 10px
    font-weight bold
.welcome,.name, .exit
  color #fff
  font-size 18px

.exit
  font-size 22px
  margin-left 10px
</style>
